<template>
	<rs-survey-response-preview
		:surveyId="surveyId"
    :targetKey="k"
	></rs-survey-response-preview>
</template>

<script>
import RsSurveyResponsePreview from "@/redsurvey/components/survey/RsSurveyResponsePreview";
export default {
  components: {
    RsSurveyResponsePreview,
  },
  computed: {
    surveyId() {
      return Number(this.$route.params.surveyId);
    },
    k() {
      return this.$route.query.k;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>